import script from "./app-breadcrumb.vue?vue&type=script&setup=true&lang=js"
export * from "./app-breadcrumb.vue?vue&type=script&setup=true&lang=js"

import "./app-breadcrumb.vue?vue&type=style&index=0&id=24ae94bc&lang=css"

export default script